(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boot-before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-before-after]').forEach((comparison) => {
    const media = comparison.querySelector('.boot-before-after__media');
    const range = comparison.querySelector('[data-before-after-range]');

    if (!media || !range) {
      return;
    }

    let frame = null;
    let nextValue = Number(range.value);

    const setPosition = (value) => {
      nextValue = Math.min(100, Math.max(0, value));

      if (frame) {
        return;
      }

      frame = requestAnimationFrame(() => {
        range.value = nextValue;
        media.style.setProperty('--before-after-position', `${nextValue}%`);
        frame = null;
      });
    };

    const updateFromPointer = (event) => {
      const rect = media.getBoundingClientRect();
      const x = event.clientX - rect.left;

      setPosition((x / rect.width) * 100);
    };

    let activePointerId = null;
    let startX = 0;
    let startY = 0;
    let isSliding = false;

    const stopSliding = (event) => {
      if (media.hasPointerCapture(event.pointerId)) {
        media.releasePointerCapture(event.pointerId);
      }

      activePointerId = null;
      isSliding = false;
    };

    media.addEventListener('pointerdown', (event) => {
      activePointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      isSliding = false;
    });

    media.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) {
        return;
      }

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!isSliding) {
        if (Math.abs(deltaX) < 10) {
          return;
        }

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          stopSliding(event);
          return;
        }

        isSliding = true;
        media.setPointerCapture(event.pointerId);
      }

      updateFromPointer(event);
    });

    media.addEventListener('pointerup', stopSliding);
    media.addEventListener('pointercancel', stopSliding);
    range.addEventListener('input', () => setPosition(Number(range.value)));
    setPosition(nextValue);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeCustomerShowcases = (root = document) => {
    root.querySelectorAll('.customer-showcase:not([data-showcase-ready])').forEach((showcase) => {
      showcase.dataset.showcaseReady = 'true';
      const dialogs = Array.from(showcase.querySelectorAll('[data-showcase-dialog]'));

      const updateMuteButton = (dialog) => {
        const video = dialog.querySelector('video');
        const button = dialog.querySelector('[data-showcase-mute]');
        if (!video || !button) return;
        const isMuted = video.muted;
        button.setAttribute('aria-pressed', String(isMuted));
        button.setAttribute('aria-label', isMuted ? button.dataset.soundOnLabel : button.dataset.soundOffLabel);
        button.querySelector('[data-showcase-sound-on]').hidden = isMuted;
        button.querySelector('[data-showcase-sound-off]').hidden = !isMuted;
      };

      const stopVideo = (dialog) => {
        const video = dialog.querySelector('video');
        if (!video) return;
        video.pause();
        video.muted = true;
        video.currentTime = 0;
        updateMuteButton(dialog);
      };

      const openDialog = (dialog) => {
        if (!dialog || dialog.open) return;
        dialog.showModal();
        document.documentElement.classList.add('customer-showcase-modal-open');
        const video = dialog.querySelector('video');
        if (!video) return;
        video.muted = false;
        video.volume = 1;
        updateMuteButton(dialog);
        const playRequest = video.play();
        if (playRequest) playRequest.catch(() => {});
      };

      const closeDialog = (dialog) => {
        if (!dialog || !dialog.open) return;
        stopVideo(dialog);
        dialog.close();
      };

      showcase.querySelectorAll('[data-showcase-open]').forEach((button) => {
        button.addEventListener('click', () => {
          openDialog(document.getElementById(button.dataset.showcaseOpen));
        });
      });

      showcase.querySelectorAll('[data-showcase-card-form]').forEach((form) => {
        const panel = form.querySelector('[data-showcase-card-panel]');
        const toggle = form.querySelector('[data-showcase-card-toggle]');
        const selectors = Array.from(form.querySelectorAll('[data-showcase-card-option]')).sort(
          (first, second) => Number(first.dataset.position) - Number(second.dataset.position)
        );
        const variantInput = form.querySelector('[data-showcase-card-variant-id]');
        const addButton = form.querySelector('[data-showcase-card-add]');
        const price = form.querySelector('[data-showcase-card-price]');
        const variantsElement = form.querySelector('[data-showcase-card-variants]');
        const variants = JSON.parse(variantsElement.textContent);

        const updateCardVariant = () => {
          const selectedOptions = selectors.map((select) => select.value);
          const variant = variants.find(
            (candidate) =>
              candidate.options.length === selectedOptions.length &&
              candidate.options.every((option, optionIndex) => option === selectedOptions[optionIndex])
          );

          if (!variant) {
            variantInput.value = '';
            addButton.disabled = true;
            addButton.textContent = addButton.dataset.soldLabel;
            return;
          }

          variantInput.value = variant.id;
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
          if (price) price.textContent = variant.price;
        };

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          showcase.querySelectorAll('[data-showcase-card-panel].is-open').forEach((openPanel) => {
            if (openPanel === panel) return;
            openPanel.classList.remove('is-open');
            openPanel.setAttribute('aria-hidden', 'true');
            openPanel.closest('form')?.querySelector('[data-showcase-card-toggle]')?.setAttribute('aria-expanded', 'false');
          });
          toggle.setAttribute('aria-expanded', String(!isOpen));
          panel.setAttribute('aria-hidden', String(isOpen));
          panel.classList.toggle('is-open', !isOpen);
        });

        selectors.forEach((select) => select.addEventListener('change', updateCardVariant));
        updateCardVariant();
      });

      dialogs.forEach((dialog, index) => {
        dialog.querySelector('[data-showcase-close]')?.addEventListener('click', () => closeDialog(dialog));

        dialog.querySelector('[data-showcase-mute]')?.addEventListener('click', () => {
          const video = dialog.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          if (!video.muted) {
            video.volume = 1;
            const playRequest = video.play();
            if (playRequest) playRequest.catch(() => {});
          }
          updateMuteButton(dialog);
        });

        dialog.querySelector('[data-showcase-previous]')?.addEventListener('click', () => {
          closeDialog(dialog);
          openDialog(dialogs[(index - 1 + dialogs.length) % dialogs.length]);
        });

        dialog.querySelector('[data-showcase-next]')?.addEventListener('click', () => {
          closeDialog(dialog);
          openDialog(dialogs[(index + 1) % dialogs.length]);
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog(dialog);
        });

        dialog.addEventListener('close', () => {
          stopVideo(dialog);
          if (!document.querySelector('[data-showcase-dialog][open]')) {
            document.documentElement.classList.remove('customer-showcase-modal-open');
          }
        });

        const form = dialog.querySelector('[data-showcase-product-form]');
        if (!form) return;

        const variantsElement = form.querySelector('[data-showcase-variants]');
        const optionSelectors = Array.from(form.querySelectorAll('[data-showcase-option]')).sort(
          (first, second) => Number(first.dataset.position) - Number(second.dataset.position)
        );
        const variantInput = form.querySelector('[data-showcase-variant-id]');
        const addButton = form.querySelector('[data-showcase-add]');
        const price = dialog.querySelector('[data-showcase-price]');
        const variants = JSON.parse(variantsElement.textContent);

        const updateVariant = () => {
          const selectedOptions = optionSelectors.map((select) => select.value);
          const variant = variants.find(
            (candidate) =>
              candidate.options.length === selectedOptions.length &&
              candidate.options.every((option, optionIndex) => option === selectedOptions[optionIndex])
          );

          if (!variant) {
            variantInput.value = '';
            addButton.disabled = true;
            addButton.textContent = addButton.dataset.soldLabel;
            return;
          }

          variantInput.value = variant.id;
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
          if (price) price.textContent = variant.price;
        };

        optionSelectors.forEach((select) => select.addEventListener('change', updateVariant));
        updateVariant();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCustomerShowcases());
  } else {
    initializeCustomerShowcases();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCustomerShowcases(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
